import React, { useEffect, useState, useRef } from 'react';
import {Button} from "react-bootstrap";
import BottomModal from './BottomModal';
import { useTranslation } from 'react-i18next';

const TerminalIdleModal = ({ open, onDismiss, onTimeout }) => {
  const [count, setCount] = useState(10);
  const intervalRef = useRef();
  const { t } = useTranslation();

  useEffect(() => {
    if (open) {
      setCount(10);
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    if (count === 0) {
      onTimeout && onTimeout();
      return;
    }
    intervalRef.current = setTimeout(() => setCount(c => c - 1), 1000);
    return () => clearTimeout(intervalRef.current);
  }, [count, open, onTimeout]);

  useEffect(() => {
    if (!open) return;
    const handle = () => onDismiss && onDismiss();
    window.addEventListener('mousedown', handle, { once: true });
    window.addEventListener('keydown', handle, { once: true });
    window.addEventListener('touchstart', handle, { once: true });
    return () => {
      window.removeEventListener('mousedown', handle, { once: true });
      window.removeEventListener('keydown', handle, { once: true });
      window.removeEventListener('touchstart', handle, { once: true });
    };
  }, [open, onDismiss]);

  return (
    <BottomModal open={open} onDismiss={onDismiss} header={<h3 className='text-black'>{t('areUhere')}</h3>}
                 footer={<Button className="btn btn-lg btn-primary w-100" onClick={onDismiss}>{t('yesContinue')}</Button>}
    >
      <div className='text-center p-2'>
        <h6 className='text-black'>{t('inactive1min')} {count} {t('sec')}...</h6>
      </div>
    </BottomModal>
  );
};

export default TerminalIdleModal;
